import { type CfAsset } from '../../types';

export enum IconType {
  App = 'App',
  Award = 'Award',
  Badge = 'Badge',
  Flag = 'Flag',
  Logo = 'Logo',
  Tile = 'Tile'
}

export const getIconType = ({ metadata }: CfAsset) => {
  if (!metadata?.tags) {
    return null;
  }
  if (metadata.tags.includes('iconTile')) {
    return IconType.Tile;
  }

  if (metadata.tags.includes('iconBadge')) {
    return IconType.Badge;
  }

  if (metadata.tags.includes('iconApp')) {
    return IconType.App;
  }

  if (metadata.tags.includes('iconFlag')) {
    return IconType.Flag;
  }

  if (metadata.tags.includes('iconAward')) {
    return IconType.Award;
  }

  if (metadata.tags.includes('iconLogo')) {
    return IconType.Logo;
  }
};
